<template>
  <div class="chart-card">
    <div class="chart-header">
      <div class="chart-title-block">
        <span class="chart-kicker">DISTRIBUCIÓN</span>
        <h3 class="chart-title">Por Categoría</h3>
      </div>
    </div>

    <div v-if="loading" class="chart-loading">Cargando…</div>
    <div v-else-if="distribucion.length === 0" class="chart-empty">Sin datos</div>
    <div v-else class="dist-list">
      <div v-for="c in distribucion.slice(0, 8)" :key="c.categoria" class="dist-row">
        <div class="dist-info">
          <span class="dist-cat" :title="c.categoria">{{ truncate(c.categoria) }}</span>
          <span class="dist-total">{{ c.total.toLocaleString() }}</span>
        </div>
        <div class="dist-bar">
          <div
            class="seg seg-win"
            :style="{ width: pct(c.ganamos, c.total) + '%' }"
            :title="`Ganamos: ${c.ganamos}`"
          >
            <span v-if="pct(c.ganamos, c.total) >= 8">{{ c.ganamos }}</span>
          </div>
          <div
            class="seg seg-lose"
            :style="{ width: pct(c.perdemos, c.total) + '%' }"
            :title="`Perdemos: ${c.perdemos}`"
          >
            <span v-if="pct(c.perdemos, c.total) >= 8">{{ c.perdemos }}</span>
          </div>
          <div
            class="seg seg-exclusive"
            :style="{ width: pct(c.exclusivos, c.total) + '%' }"
            :title="`Exclusivos: ${c.exclusivos}`"
          >
            <span v-if="pct(c.exclusivos, c.total) >= 8">{{ c.exclusivos }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="chart-legend">
      <div class="leg-item"><span class="leg-box leg-win"></span>Ganamos</div>
      <div class="leg-item"><span class="leg-box leg-lose"></span>Perdemos</div>
      <div class="leg-item"><span class="leg-box leg-exclusive"></span>Exclusivos</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, defineProps } from 'vue';
import axios from 'axios';

const props = defineProps({
  vista: { type: String, default: 'web' }
});

const API = 'https://dash-visaovip.kompara.tech/api';
const getH = () => ({ headers: { Authorization: 'Bearer ' + localStorage.getItem('token_precios') } });

const distribucion = ref([]);
const loading = ref(true);

const pct = (val, total) => total > 0 ? (val / total * 100) : 0;
const truncate = (s, n = 22) => s && s.length > n ? s.slice(0, n) + '…' : s;

const load = async () => {
  loading.value = true;
  try {
    const res = await axios.get(`${API}/stats/distribucion-por-categoria`, {
      ...getH(), params: { vista: props.vista }
    });
    distribucion.value = res.data.distribucion || [];
  } catch (e) {
    console.error(e);
  } finally {
    loading.value = false;
  }
};

watch(() => props.vista, load);
onMounted(load);
</script>

<style scoped>
.chart-card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.chart-header {
  padding: 10px 14px;
  background: var(--color-surface-3);
  border-bottom: 1px solid var(--color-accent-border);
}
.chart-kicker {
  display: block;
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.15em;
  color: var(--color-accent);
  text-transform: uppercase;
}
.chart-title {
  margin: 2px 0 0;
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text);
}
.chart-loading, .chart-empty {
  padding: 40px 20px;
  text-align: center;
  color: var(--color-text-muted);
  font-family: var(--font-mono);
  font-size: 11px;
}

.dist-list {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}
.dist-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.dist-info {
  display: flex;
  justify-content: space-between;
  font-family: var(--font-mono);
  font-size: 10.5px;
}
.dist-cat {
  color: var(--color-text);
  font-weight: 600;
  font-family: 'Inter', sans-serif;
}
.dist-total {
  color: var(--color-text-faint);
  font-variant-numeric: tabular-nums;
}
.dist-bar {
  display: flex;
  height: 18px;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 2px;
  overflow: hidden;
}
.seg {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-mono);
  font-size: 9px;
  font-weight: 700;
  color: white;
  min-width: 0;
}
.seg-win { background: var(--color-success); }
.seg-lose { background: var(--color-danger); }
.seg-exclusive { background: var(--color-accent); color: var(--color-surface-3); }

.chart-legend {
  padding: 8px 14px;
  background: var(--color-surface-2);
  border-top: 1px solid var(--color-border);
  display: flex;
  gap: 14px;
  font-family: var(--font-mono);
  font-size: 9.5px;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.leg-item {
  display: flex;
  align-items: center;
  gap: 5px;
}
.leg-box {
  width: 10px;
  height: 8px;
  border-radius: 1px;
}
.leg-win { background: var(--color-success); }
.leg-lose { background: var(--color-danger); }
.leg-exclusive { background: var(--color-accent); }
</style>